import React, { useMemo } from 'react';

import { FormControl, MenuItem, Select } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import processing_activities_messages from 'messages/processing_activities_messages';

import useStyles from '../ProcessingActivitiesPage.styles';

type Option = {
  value: string;
  label: string;
};

type Props = {
  allLabel: string;
  ariaLabel: string;
  includeEmptyOption?: boolean;
  onChange: (value: string) => void;
  options: Option[];
  value: string;
};

const ProcessingActivitiesFilterSelect: React.FC<Props> = ({
  allLabel,
  ariaLabel,
  includeEmptyOption = true,
  onChange,
  options,
  value,
}) => {
  const styles = useStyles();

  const renderValue = (selected: unknown) => {
    const selectedValue = selected as string;
    if (!selectedValue && includeEmptyOption) {
      return allLabel;
    }

    return options.find(option => option.value === selectedValue)?.label ?? selectedValue;
  };

  return (
    <FormControl className={styles.filterSelect} size='small' variant='outlined'>
      <Select
        displayEmpty={includeEmptyOption}
        inputProps={{ 'aria-label': ariaLabel }}
        onChange={event => onChange(event.target.value as string)}
        renderValue={renderValue}
        value={value}
      >
        {includeEmptyOption && <MenuItem value=''>{allLabel}</MenuItem>}
        {options.map(option => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export const useStatusFilterOptions = () => {
  const { t } = useTranslation();

  return useMemo(
    () => [
      { value: 'published', label: t(processing_activities_messages.filters.status_published) },
      { value: 'all', label: t(processing_activities_messages.filters.status_all) },
      { value: 'archived', label: t(processing_activities_messages.filters.status_archived) },
    ],
    [t],
  );
};

export default ProcessingActivitiesFilterSelect;
